import React, {useMemo} from "react";
import router, {Route} from "@/routing/Router";
import AdminLayout from "@widgets/layout/AdminLayout";
import MenuOverview from "@widgets/menu/MenuOverview";


const Menu = () => {
    const route: Route = useMemo(() => router.menu, []);

    return (
        <AdminLayout currentPage={route}>
            <MenuOverview route={route}/>
        </AdminLayout>
    );
};

export default Menu;